module.exports = __webpack_public_path__ + "img/a10.4b457caa.png";